export const AppConstant = {
  localStorage: {
    userId: "userId",
    selectedDate: "selectedDate",
    tenantId: "tenantId",
    teamId: "teamId",
    companyName: "companyName",
    IsCLLogin: "IsCLLogin",
    Domain: "capitaland.com",
    toTime: "toTime",
    fromtime: "fromTime",
    duration: "duration",
    bookingDate: "bookingDate",
    hostEmaild: "hostEmailid",
    meeting: "meeting",
    token: "token",
    bookingId: "bookingId",
    locationId: "locationId",
    status: "",
    bookedBy: "user",
    createdBy: "",
    isAdmin: "isAdmin",
    totalCreditConsumed: "totalCreditConsumed",
    changeHour: "changeHour",
    changeMinute: "changeMinute",
    changeamorpm: "changeamorpm",
    selectedHost: "selectedHost",
    loginAttemptsCount: "loginAttemptsCount",
    selectedMember: "selectedMember",
    parkTenantId: "parkTenantId",
    adminName: "adminName"
  },
}
